import Modal from '@components/v2/ui/Modal/Modal';
import { memo, useState } from 'react';
import useMockLoading from '../../../components/Hooks/useMockLoading';
import LangEnum from '../../../lang/LangEnum';
import { useTranslation } from '../../translation/TranslationContext';
import { useAcceptSuggestedOrder } from '../hooks/useAcceptSuggestedOrder';
import { AcceptSuggestionOrderContent } from './components/AcceptSuggestionOrderContent';

interface IAcceptSuggestionOrderModal {
  isOpen: boolean;
  orderCode: string | undefined;
  onClose: () => void;
}

const AcceptSuggestionOrderModal = ({
  isOpen,
  orderCode,
  onClose,
}: IAcceptSuggestionOrderModal) => {
  const [gridMultiplier, setGridMultiplier] = useState(1);
  const [hasToMaintainOriginalParts, setHasToMaintainOriginalParts] = useState(true);
  const { translate } = useTranslation();
  const { acceptedSuggestedOrder } = useAcceptSuggestedOrder({ onClose });

  const onChangeObtainGridMultiplier = (value: number, maintainOriginalParts: boolean) => {
    setGridMultiplier(value);
    setHasToMaintainOriginalParts(maintainOriginalParts);
  };

  const acceptSuggestionOrder = async () => {
    await acceptedSuggestedOrder({
      gridMultiplier,
    });
  };

  const { isLoading: loading, handleAsyncFunction: handleAcceptSuggestionOrder } = useMockLoading<
    void,
    void
  >({
    asyncFunction: acceptSuggestionOrder,
  });

  const isInvalidMultiplier = !hasToMaintainOriginalParts && gridMultiplier <= 1;

  const onCloseAcceptModal = () => {
    if (loading) {
      return;
    }
    onClose();
    setGridMultiplier(1);
    setHasToMaintainOriginalParts(true);
  };

  return (
    <Modal
      isOpen={isOpen}
      size="standard"
      header={{
        title: `${translate(LangEnum.SUGGESTED_ORDER_ACCEPT_ORDER_SUGGESTED)} ${orderCode}`,
      }}
      onClose={onCloseAcceptModal}
      footer={{
        primaryAction: {
          label: LangEnum.GLOBAL_COPY_FINALIZE,
          isDisabled: isInvalidMultiplier,
          tooltipMessage: isInvalidMultiplier
            ? LangEnum.SUGGESTED_ORDER_ACCEPT_MULTIPLIER_HIGHER_ONE
            : undefined,
          isLoading: loading,
          onClick: handleAcceptSuggestionOrder,
        },
        secondaryAction: { label: LangEnum.GLOBAL_GO_BACK, onClick: onCloseAcceptModal },
      }}
    >
      <AcceptSuggestionOrderContent onChangeInsertGridMultiplier={onChangeObtainGridMultiplier} />
    </Modal>
  );
};

export default memo(AcceptSuggestionOrderModal);
